import { useEffect } from 'react';
import { useIdentity } from '@/auth/useIdentity';
import { initializePendo } from '@/services/pendoService';

/**
 * Initialises Pendo analytics once the current user identity is available.
 *
 * Consumes the shared, auth-gated `useIdentity` (identity decoded from the token
 * claims, the same source as the app header; there is no `/me` request) and runs
 * the injection a single time when the user becomes available. Gating matters
 * here because `usePendo` runs on every route — including `/auth/callback` — so
 * an ungated read would run before login completes and no token exists yet
 * (see COPA-221).
 */
export function usePendo(): void {
  const { user: currentUser } = useIdentity();

  useEffect(() => {
    if (currentUser) {
      initializePendo(currentUser);
    }
  }, [currentUser]);
}
